<template>
  <section class="pda-default">
    <!-- <no-data v-if="!examsList.length && dataLoadState"></no-data> -->
    <div class="mgt-16" v-if="!examsList.length && dataLoadState">
      <div
        class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pdt-24 pdb-20"
      >
        <div class="d-flex justify-content-center flex-column">
          <div class="t-center">
            <img src="images/no-data1.svg" alt="" class="w-44 h-44 mgx-auto" />
          </div>
          <div
            class="t-color-content1 t-body3 l-spacing42 t-center mgt-24 font-r"
          >
            {{ $t("1964") }}
          </div>
        </div>
      </div>
    </div>

    <div class="mdc-card mdc-elevation--z3" v-if="examsList.length">
      <div class="t-subtitle2 mgt-16 mgb-16 mgl-16 mgr-16">
        {{ $t("183") }}
        <!-- 정규평가 -->
      </div>

      <div v-for="(exam, index) in examsList" :key="index" class="ripple-item">
        <div
          class="d-flex flex-row justify-content-between pdt-12 pdb-16 mgl-8 mgr-8"
        >
          <div class="pdl-8 pdr-8" v-if="exam.icon">
            <img :src="exam.icon" class="profile" />
          </div>
          <div class="pdl-8 pdr-8 flex-grow-1">
            <div class="t-body1">
              {{ exam.name }}
              <div class="t-body3 t-color-gray2">
                <div
                  v-if="exam.status === 'COMPLETION'"
                  @click="takeFinalExam(exam.examineeId)"
                >
                  <!-- <div> -->
                  <span>
                    {{ $t("184") }}
                    <!-- 응시완료 -->
                  </span>
                  <div class="t-body2 t-color-blue2">
                    {{ $t("185", { str: exam.score }) }}
                    <!-- {{exam.score}}점 -->
                  </div>
                </div>

                <div v-if="exam.status === 'WAITING'">
                  <!-- <div> -->
                  <span>
                    {{ $t("923") }}
                    <!-- 응시대기 -->
                  </span>
                  <div class="t-body2 t-color-blue2">
                    {{
                      $t("924", {
                        str: $moment(exam.application.start).format("L"),
                      })
                    }}
                    <!-- {{$moment(exam.application.start).format('L')}}부터 응시가능 -->
                    <!-- to-do 진도율 조건 -->
                  </div>
                </div>

                <div
                  v-if="exam.status === 'APPLICABLE'"
                  @click="takeFinalExam(exam.examineeId)"
                >
                  <!-- <div> -->
                  <span>
                    {{
                      $t("186", {
                        str: $moment(exam.application.end).format("L"),
                      })
                    }}
                    <!-- {{$moment(exam.application.end).format('L')}}까지 응시가능 -->
                  </span>
                  <div class="t-body2 t-color-blue2">
                    {{ $t("190") }}
                    <!-- 시험을 응시해주세요 -->
                  </div>
                </div>

                <div
                  v-if="exam.status === 'REAPPLICATION'"
                  @click="takeFinalExam(exam.examineeId)"
                >
                  <!-- <div> -->
                  <span>
                    {{
                      $t("186", {
                        str: $moment(exam.application.end).format("L"),
                      })
                    }}
                    <!-- {{$moment(exam.application.end).format('L')}}까지 응시가능 -->
                  </span>
                  <div class="t-body2 t-color-blue2">
                    {{ $t("185", { str: exam.score }) }}
                    <!-- {{exam.score}}점 -->
                    <span class="t-body3 t-color-red1">
                      {{ $t("188") }}
                      <!-- 재응시 필요합니다 -->
                    </span>
                  </div>
                </div>

                <div v-if="exam.status === 'TERMINATION'">
                  <!-- <div> -->
                  <span>
                    {{ $t("922") }}
                    <!-- 시험종료 -->
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex flex-row" v-if="index < examsList.length - 1">
          <div class="mgl-16 mgr-16 w-40" v-if="exam.icon"></div>
          <div class="flex-grow-1">
            <hr class="divider" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
/**
 * 나의 학습 상세 - 정규평가 탭 컴포넌트(my learning view - exam tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import httpService from "@/api/httpService";
import learnApi from "@/api/learnApi.js";
import NoData from "../../common/NoData.vue";
import { MDCRipple } from "@material/ripple";
export default {
  components: {
    "no-data": NoData,
  },
  data() {
    return {
      examsList: [],
      dataLoadState: false,
    };
  },
  mounted() {
    this.fetchData();
  },

  updated() {
    const ripples = [].map.call(
      document.querySelectorAll(".ripple-item"),
      function (el) {
        let ripple = new MDCRipple.attachTo(el);
        return ripple;
      }
    );
  },

  methods: {
    // 시험정보 API 호출 및 데이터 설정(get exam list data)
    fetchData() {
      let responseData = null;
      let params = this.setParams();

      this.$showLoading(this.$refs.examList);
      learnApi
        .learnViewExams(params)
        .then((response) => {
          this.examsList = response.data.data;
          this.$hideLoading();
          this.dataLoadState = true;

          let applicableExamList = _.filter(this.examsList, function (o) {
            return o.status === "APPLICABLE" || o.status === "REAPPLICATION";
          });

          if (applicableExamList) {
            let examineeId = _.head(applicableExamList).examineeId;
            this.setExamineeId(examineeId);
          }
        })
        .catch((err) => {});
    },

    // 파라미터 설정(set parameter)
    setParams() {
      const params = {
        learnId: this.$route.params.learnId,
      };
      return params;
    },

    // 시험응시(move take exam)
    takeFinalExam(examineeId) {
      this.$router.push({
        name: "FinalExamIntro",
        params: {
          learnId: this.$route.params.learnId,
          examineeId: examineeId,
        },
        query: this.$route.query,
      });
    },

    setExamineeId(examineeId) {
      this.$emit("setExamineeId", examineeId);
    },
  },
};
</script>